<template>
   <div>
      <v-list-item-subtitle class="text-wrap">

      </v-list-item-subtitle>
      <v-data-table :headers="headers" :items="listitems" sort-by="no" class="border" hide-default-footer dense>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Candidates</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-select
               v-model="syncPositionId"
               :items="positions"
               item-value="id"
               item-text="title"
               label="Position to sync"
               outlined
               dense
               hide-details
               style="max-width: 260px;"
               class="mr-2"
            ></v-select>
            <v-btn color="orange darken-1" dark class="mb-2 mr-2" :loading="syncing" @click="syncFromNomination">
               <v-icon left small>mdi-sync</v-icon>
               Sync from Nomination
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="additem">New Item</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="dlgedit" width="800" persistent>
         <v-card>
            <v-card-title>Edit Candidate</v-card-title>
            <v-card-text>
               <v-form v-model="isvalid">
                  <v-select
                     v-model="selectedPositionId"
                     :items="positions"
                     item-value="id"
                     item-text="title"
                     label="Select Position"
                     :rules="[v => !!v || 'Position is required']"
                     outlined
                     dense
                  ></v-select>
                  <v-autocomplete
                     v-model="selectedCandidateUserid"
                     :items="candidateMembers"
                     :search-input.sync="candidateSearch"
                     :loading="candidateLoading"
                     :item-text="memberLabel"
                     item-value="userid"
                     label="Search Candidate"
                     hint="Search by name, Member ID, or IC/Passport. Candidate name and Member ID will be filled automatically."
                     persistent-hint
                     clearable
                     outlined
                     dense
                     :rules="[v => !!v || 'Candidate is required']"
                     @change="selectCandidate"
                  >
                     <template v-slot:item="{ item }">
                        <v-list-item-avatar size="32">
                           <v-img v-if="item.photolink" :src="photoUrl(item)"></v-img>
                           <v-avatar v-else color="blue lighten-5" size="32">
                              <span class="primary--text">{{ initials(item.fullname) }}</span>
                           </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                           <v-list-item-title>{{ item.fullname }}</v-list-item-title>
                           <v-list-item-subtitle>{{ item.memberid }} · {{ item.membertype }} · {{ item.contactemail || '-' }}</v-list-item-subtitle>
                        </v-list-item-content>
                     </template>
                     <template v-slot:selection="{ item }">
                        <v-chip small>
                           {{ item.fullname }} — {{ item.memberid }}
                        </v-chip>
                     </template>
                  </v-autocomplete>
                  <v-row dense>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formmodel.cndname" label="Candidate Name" readonly outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formmodel.cndmemberid" label="Member ID" readonly outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea v-model="formmodel.description" label="Description" outlined dense rows="3"></v-textarea>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea v-model="formmodel.details" label="Details" outlined dense rows="3"></v-textarea>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-switch v-model="formmodel.isuncontested" label="Uncontested"></v-switch>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-switch v-model="formmodel.isappointed" label="Appointed"></v-switch>
                     </v-col>
                  </v-row>
               </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="updateItem">
                  Update
               </v-btn>
               <v-btn color="success" @click="dlgedit = false">
                  Close
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
      <v-dialog v-model="dlgadd" width="600" persistent>
         <v-card>
            <v-card-title>New Candidate</v-card-title>
            <v-card-text>
               <v-form v-model="isvalid">
                  <v-select
                     v-model="selectedPositionId"
                     :items="positions"
                     item-value="id"
                     item-text="title"
                     label="Select Position"
                     :rules="[v => !!v || 'Position is required']"
                     outlined
                     dense
                  ></v-select>
                  <v-autocomplete
                     v-model="selectedCandidateUserid"
                     :items="candidateMembers"
                     :search-input.sync="candidateSearch"
                     :loading="candidateLoading"
                     :item-text="memberLabel"
                     item-value="userid"
                     label="Search Candidate"
                     hint="Search by name, Member ID, or IC/Passport. Candidate name and Member ID will be filled automatically."
                     persistent-hint
                     clearable
                     outlined
                     dense
                     :rules="[v => !!v || 'Candidate is required']"
                     @change="selectCandidate"
                  >
                     <template v-slot:item="{ item }">
                        <v-list-item-avatar size="32">
                           <v-img v-if="item.photolink" :src="photoUrl(item)"></v-img>
                           <v-avatar v-else color="blue lighten-5" size="32">
                              <span class="primary--text">{{ initials(item.fullname) }}</span>
                           </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                           <v-list-item-title>{{ item.fullname }}</v-list-item-title>
                           <v-list-item-subtitle>{{ item.memberid }} · {{ item.membertype }} · {{ item.contactemail || '-' }}</v-list-item-subtitle>
                        </v-list-item-content>
                     </template>
                     <template v-slot:selection="{ item }">
                        <v-chip small>
                           {{ item.fullname }} — {{ item.memberid }}
                        </v-chip>
                     </template>
                  </v-autocomplete>
                  <v-row dense>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formmodel.cndname" label="Candidate Name" readonly outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="formmodel.cndmemberid" label="Member ID" readonly outlined dense></v-text-field>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea v-model="formmodel.description" label="Description" outlined dense rows="3"></v-textarea>
                     </v-col>
                     <v-col cols="12">
                        <v-textarea v-model="formmodel.details" label="Details" outlined dense rows="3"></v-textarea>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-switch v-model="formmodel.isuncontested" label="Uncontested"></v-switch>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-switch v-model="formmodel.isappointed" label="Appointed"></v-switch>
                     </v-col>
                  </v-row>
               </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="createItem">
                  Add
               </v-btn>
               <v-btn color="success" @click="dlgadd = false">
                  Close
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>No.</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.no : '' }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Title</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ (todelete) ? todelete.title : '' }}</small>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="dodelete(todelete)">
                  Yes
               </v-btn>
               <v-btn color="primary" dark @click="closeconfirm">
                  No
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
const axios = require('axios')
import ElectionCandidateModel from '../Forms/ElectionCandidateModel.js'

export default {
   name: "TableElectionCandidates",
   components: {},

   props: {
      electid: {
         type: [Number, String],
         default: null,
      },
   },

   data: () => ({
      user: Object,
      errors: Object,
      search: '',
      headers: [
         {
            text: "No.",
            align: "start",
            sortable: true,
            width: "70",
            value: "no",
         },
         {
            text: "Candidate Name",
            sortable: false,
            value: "candidatename"
         },
         { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      tab: null,
      listitems: [],
      dlgconfirm: false,
      dlgedit: false,
      dlgadd: false,
      editedIndex: -1,
      editedItem: Object,
      todelete: Object,
      defaultItem: Object,
      formmodel: ElectionCandidateModel,
      isvalid: false,
      positions: [],
      selectedPositionId: null,
      selectedCandidateUserid: null,
      candidateMembers: [],
      candidateSearch: '',
      candidateLoading: false,
      candidateSearchTimer: null,
      editedRecordId: null,
      syncPositionId: null,
      syncing: false,
   }),

   computed: {

   },

   watch: {
      electid: {
         immediate: true,
         handler(newVal) {
            if (newVal) {
               this.loadPositions()
               this.initialize()
            } else {
               this.listitems = []
               this.positions = []
            }
         }
      },
      candidateSearch(value) {
         clearTimeout(this.candidateSearchTimer)
         this.candidateSearchTimer = setTimeout(() => {
            this.loadCandidateMembers(value)
         }, 250)
      }
   },

   mounted() {
      this.user = this.$page.user;
      this.errors = this.$page.errors;
      this.initialize();
      this.loadCandidateMembers('');
   },

   methods: {
      loadCandidateMembers(search = '') {
         this.candidateLoading = true
         axios.get('/admin/agm/electioncandidate-members', { params: { search: search || '' } })
            .then(({ data }) => {
               this.candidateMembers = data.status === 'OK' && Array.isArray(data.data) ? data.data : []
            })
            .catch(() => { this.candidateMembers = [] })
            .finally(() => { this.candidateLoading = false })
      },

      memberLabel(item) {
         if (!item) return ''
         return `${item.fullname || '-'} — ${item.memberid || '-'} (${item.membertype || '-'})`
      },

      photoUrl(item) {
         if (!item || !item.photolink) return ''
         if (/^(https?:)?\/\//.test(item.photolink) || item.photolink.charAt(0) === '/') return item.photolink
         return '/' + item.photolink
      },

      initials(name) {
         return String(name || '?').trim().split(/\s+/).slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase()
      },

      selectCandidate(userid) {
         const member = this.candidateMembers.find(item => String(item.userid) === String(userid))
         if (!member) {
            this.formmodel.cndname = ''
            this.formmodel.cndmemberid = ''
            return
         }

         this.formmodel.cndname = member.fullname || ''
         this.formmodel.cndmemberid = member.memberid || ''
      },

      loadPositions() {
         if (!this.electid) return
         axios.get('/admin/agm/electionpositions/' + this.electid)
            .then(({ data }) => {
               this.positions = data.status === 'OK' && Array.isArray(data.data) ? data.data : []
            })
            .catch(() => { this.positions = [] })
      },

      syncFromNomination() {
         if (!this.syncPositionId) {
            this.errors = 'Please select a Position to sync from Nomination.'
            return
         }
         this.syncing = true
         axios.post('/admin/agm/electioncandidate/syncfromnomination', { electid: this.electid, positionid: this.syncPositionId })
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error
                  return
               }
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to sync candidates from nomination.' })
            .finally(() => { this.syncing = false })  
      },

      initialize() {
         if (!this.electid) {
            this.listitems = []
            return
         }
         axios.get('/admin/agm/electioncandidates/' + this.electid)
            .then(({ data }) => {
               if (data.status === 'OK' && Array.isArray(data.data)) {
                  this.listitems = data.data.map((item, idx) => ({
                     ...item,
                     no: idx + 1,
                     candidatename: item.cndname,
                  }))
               } else {
                  this.listitems = []
               } 
            })
            .catch(() => { this.errors = 'Unable to load candidates.' })
      },

      additem() {
         this.formmodel = {
            cndname: "", cndmemberid: "", description: "", details: "",
            isuncontested: false, isappointed: false,
         }
         this.selectedPositionId = null
         this.selectedCandidateUserid = null
         this.candidateSearch = ''
         this.dlgadd = true
      },

      createItem() {
         if (!this.selectedPositionId) {
            this.errors = 'Please select a Position.'
            return
         }
         if (!this.formmodel.cndname || !this.formmodel.cndmemberid) {
            this.errors = 'Please search and select a candidate.'
            return
         }
         const payload = {
            ...this.formmodel,
            electid: this.electid,
            positionid: this.selectedPositionId,
         }
         axios.post('/admin/agm/electioncandidate/add', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error
                  return
               }
               this.dlgadd = false
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to create candidate.' })
      },

      editItem(pItem) {
         this.editedRecordId = pItem.id
         this.selectedPositionId = pItem.positionid
         this.selectedCandidateUserid = null
         this.candidateSearch = pItem.cndname || pItem.cndmemberid || ''
         this.loadCandidateMembers(this.candidateSearch)
         this.formmodel = {
            cndname: pItem.cndname || "",
            cndmemberid: pItem.cndmemberid || "",
            description: pItem.description || "",
            details: pItem.details || "",
            isuncontested: !!pItem.isuncontested,
            isappointed: !!pItem.isappointed,
         }
         this.dlgedit = true},

      updateItem() {
         if (!this.selectedPositionId) {
            this.errors = 'Please select a Position.'
            return
         }
         if (!this.formmodel.cndname || !this.formmodel.cndmemberid) {
            this.errors = 'Please search and select a candidate.'
            return
         }
         const payload = {
            ...this.formmodel,
            id: this.editedRecordId,
            positionid: this.selectedPositionId,
         }
         axios.post('/admin/agm/electioncandidate/update', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  this.errors = data.error
                  return
               }
               this.dlgedit = false
               this.editedRecordId = null
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to update candidate.' })
      },

      closeconfirm() {
         this.todelete = null
         this.dlgconfirm = false
      },

      deleteItem(pItem) {
         this.todelete = pItem
         this.dlgconfirm = true
      },

      dodelete(pItem) {
         if (!pItem) return
         axios.post('/admin/agm/electioncandidate/delete', { id: pItem.id })
            .then(() => {
               this.dlgconfirm = false
               this.todelete = null
               this.initialize()
            
            })
            .catch(() => { this.errors = 'Unable to delete candidate.' })
      },
   },

}
</script>
